var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mounted)?_c('div',{class:_vm.defaultClasses,domProps:{"innerHTML":_vm._s(_vm.code)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }